import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { ClipLoader } from "react-spinners";
import swal from "sweetalert";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { utils } from "~/utils";
import { service as site_id_vs_run_id_service } from "../redux";
import { UncontrolledAlert } from 'reactstrap';


class SiteVsRunReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            message_response: ''
        };
    }

    render() {
        let date = new Date();

        return (
            <div>
                <div className="row justify-content-center">
                    {this.state.message_response && (
                        <div className="col-md-12">
                            <UncontrolledAlert color="info">
                                {this.state.message_response}
                            </UncontrolledAlert>
                        </div>
                    )}
                    <div className="col-md-6">
                        <Formik onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                const { values, setFieldValue } = formik;
                                return (
                                    <Form>
                                        <div className="row">
                                            <div className="form-group col-6">
                                                <label>Start date</label>
                                                <Field
                                                    component={DatePicker}
                                                    dateFormat="dd/MM/yyyy"
                                                    onChange={value => setFieldValue("start_date", value, false)}
                                                    name="start_date"
                                                    autoComplete="off"
                                                    maxDate={date}
                                                    selected={values.start_date}
                                                    className="form-control"
                                                    validate={utils.validateGeneral}
                                                />
                                                {this.renderError(formik, "start_date")}
                                            </div>
                                            <div className="form-group col-6">
                                                <label>End date</label>
                                                <Field
                                                    component={DatePicker}
                                                    dateFormat="dd/MM/yyyy"
                                                    onChange={value => setFieldValue("end_date", value, false)}
                                                    name="end_date"
                                                    maxDate={date}
                                                    autoComplete="off"
                                                    selected={values.end_date}
                                                    className="form-control"
                                                    validate={utils.validateGeneral}

                                                />
                                                {this.renderError(formik, "end_date")}
                                            </div>
                                            <div className="form-group col-6">
                                                <label>OET Id</label>
                                                <Field
                                                    name="oet_id"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Customer team</label>
                                                <Field
                                                    name="customers_team_name"
                                                    component={Select}
                                                    value={values.customers_team_name}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    options={[
                                                        { value: "bharti_infratel_limited", label: "Bharti infratel limited" },
                                                        { value: "Indian_Railways", label: "Indian Railways" },
                                                        { value: "Alstom", label: "ALSTOM" },
                                                        { value: "MTNL", label: "MTNL" },
                                                        { value: "BSNL", label: "BSNL" },
                                                        { value: "vodafone_idea_limited_india", label: "Vodafone idea india" },
                                                        { value: "bharti_airtel_india_parser", label: "Bharti Airtel India" },
                                                        { value: "reliance_jio_parser", label: "Reliance Jio" },
                                                    ]}
                                                    onChange={val => setFieldValue("customers_team_name", val, false)}
                                                    validate={utils.validateGeneral}
                                                />
                                                {this.renderError(formik, "customers_team_name")}
                                            </div>
                                            <div className="form-group col-6">
                                                <label>CPO number</label>
                                                <Field
                                                    name="cpo_number"
                                                    className="form-control"
                                                />
                                            </div>
                                            
                                        </div>
                                        <button type="submit" className="btn btn-success">
                                            Send report to email
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    renderError = (formik, type) => {
        if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
            return <small className="text-danger form-text">{formik.errors[type]}</small>;
        }
        return null;
    };

    handleSubmit = values => {
        let months = utils.dateValidation(values.start_date, values.end_date)
        if (months >= 3){
            swal({
                title: "Error",
                text: "Date range exceeds the maximum of 3 months",
                icon: "error",
                button: true
                });
            this.setState({message_response: 'Date range exceeds the maximum of 3 months'})
            return
        }
        let request = utils.clearObjectNulls({
            customers_team_name: values && values.customers_team_name ? values.customers_team_name.value : null,
        });
        request.cpo_number = values.cpo_number
        request.oet_id = values.oet_id
        request.start_date = values.start_date
        request.end_date = values.end_date
        const errorMessage = () => {
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        };
        this.setState({ isLoadig: true, message_response: "" });
        site_id_vs_run_id_service
            .getSiteVsRunReport(request)
            .then(response => {
                this.setState({ isLoadig: false, message_response: response.data.detail })
            })
            .catch(response => {
                this.setState({ isLoadig: false });
                errorMessage();
            });
    };
}

export default SiteVsRunReport;
